import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import EmergencyHealthResponseDetails from '../../subdepartmentdetails/EmergencyHealthResponse'


function EmergencyHealthResponse() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Emergency Health Response and Preparedness || Health and Human Services";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Health Human Services"
            title="Emergency Health Response & Preparedness"
            subtitledown="Department of Health & Human Services"
           />
            <EmergencyHealthResponseDetails/>
        </div>
    </>
  )
}

export default EmergencyHealthResponse